import { memo } from "react";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";

import { API_KEY_ROLES_COLUMN_ID } from "../constants";
import ApiKeyRolesListItemDescriptionCell from "./DescriptionCell";
import ApiKeyRolesListItemActionsDropdownCell from "./DropdownActionsCell";
import ApiKeyRolesListItemNameCell from "./NameCell";
import ApiKeyRolesListItemGrantedAtCell from "./GrantedAtCell";
import { ApiKeyViewRoleBinding } from "../../types";

const CELLS = {
  [API_KEY_ROLES_COLUMN_ID.DESCRIPTION]: ApiKeyRolesListItemDescriptionCell,
  [API_KEY_ROLES_COLUMN_ID.NAME]: ApiKeyRolesListItemNameCell,
  [API_KEY_ROLES_COLUMN_ID.DROPDOWN]: ApiKeyRolesListItemActionsDropdownCell,
  [API_KEY_ROLES_COLUMN_ID.GRANTED_AT]: ApiKeyRolesListItemGrantedAtCell,
};

type ApiKeyRolesListItemProps = {
  roleBinding: ApiKeyViewRoleBinding;
  isLastRole?: boolean;
};

const ApiKeyRolesListItem = (props: ApiKeyRolesListItemProps) => {
  const { roleBinding, isLastRole = false } = props;

  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as API_KEY_ROLES_COLUMN_ID];
        const uniqueKey = `${id}-${roleBinding.id}`;

        const childrenComponent = <Component roleBinding={roleBinding} isLastRole={isLastRole} />;

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(ApiKeyRolesListItem);
